import { ICashFlowStatement } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class CashFlow {
    constructor(public cashFlowStatement: ICashFlowStatement) {}

    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
